import i18n from '@/plugins/i18n';

/**
 * @package
 * @author Artem Ilinykh devsinglesly@gmail.com
 * @class Resource
 */
export class Resource {
  private id!: number;
  private readonly title!: string;
  private readonly resource!: string;

  public getId(): number {
    return this.id;
  }

  public getTitle(): string {
    if (this.isColdWater) {
      return String(i18n.t('screens.account.counters.resource_types.cold'));
    }

    if (this.isHotWater) {
      return String(i18n.t('screens.account.counters.resource_types.hot'));
    }

    if (this.isHeat) {
      return String(i18n.t('screens.account.counters.resource_types.heat'));
    }

    if (this.isGas) {
      return String(i18n.t('screens.account.counters.resource_types.gas'));
    }

    if (this.isEnergy) {
      return String(i18n.t('screens.account.counters.resource_types.energy'));
    }

    return '';
  }

  public getBackendTitle(): string {
    return this.title;
  }

  public getResource(): string {
    return this.resource;
  }

  public get isEnergy(): boolean {
    return this.resource === 'energy';
  }

  public get isColdWater(): boolean {
    return this.resource === 'cold.water';
  }

  public get isHotWater(): boolean {
    return this.resource === 'hot.water';
  }

  public get isGas(): boolean {
    return this.resource === 'gas';
  }

  public get isHeat(): boolean {
    return this.resource === 'heat';
  }
}
